import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { Router as RouterProvider, Route, Switch } from 'react-router-dom';
import appStore from './store';
import { createGlobalStyle } from 'styled-components';
import { createBrowserHistory } from 'history';
import BSReboot from './assets/styles/bootstrap-reboot';
import GlobalStyles from './assets/styles/global-styles';
import Layout from './components/layout';
import ScrollToTop from './utils/scroll-top';
import IntlLayout from './components/intl-layout';

import { LOG_IN } from './redux/action/types';
import UnauthorizedLayout from './components/unauthorized-layout';
import { ROUTE_MOBILE_SIGNATURE, ROUTE_PHONE_VERIFICATION_REQUIRED } from './constants';
import MobileSignaturePage from './pages/mobile-signature';
import PhoneVerificationRequired from './pages/phone-verification-required';

const browserHistory = createBrowserHistory();
const BsStyles = createGlobalStyle`${BSReboot}`;
const GlobalStyle = createGlobalStyle`${GlobalStyles}`;

class App extends React.PureComponent {
  componentDidMount() {
    appStore.dispatch({
      type: LOG_IN,
    });
  }

  render() {
    return (
      <ReduxProvider store={appStore}>
        <RouterProvider history={browserHistory}>
          <IntlLayout>
            <ScrollToTop>
              <BsStyles />
              <GlobalStyle />
              <Switch>
                <Route exact path={ROUTE_MOBILE_SIGNATURE} component={MobileSignaturePage} />
                <Route exact path={ROUTE_PHONE_VERIFICATION_REQUIRED} component={PhoneVerificationRequired} />
                <Route
                  path="/"
                  render={() => (this.props.loginStatus === true ? <Layout /> : <UnauthorizedLayout />)}
                />
              </Switch>
            </ScrollToTop>
          </IntlLayout>
        </RouterProvider>
      </ReduxProvider>
    );
  }
}

export default App;
